// extracted by mini-css-extract-plugin
export default {"container":"LoadingPanel_container__JzyGF"};